var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"b-main-wrapper",style:({
         height: _vm.height,
     })},[_c('transition',{attrs:{"name":"fade"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageStatus),expression:"imageStatus"}],staticClass:"icon",staticStyle:{"height":"100%"},attrs:{"src":_vm.src},on:{"load":_vm.onLoaded}}),_vm._v("  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }